// src/components/common/Modal.jsx
import React from "react";
import ReactDOM from "react-dom";

/**
 * Modal - simple accessible modal
 * Props: open, onClose, title, children, showCloseButton
 */
export default function Modal({
  open,
  onClose,
  title,
  children,
  showCloseButton = true,
  maxWidth = "max-w-2xl",
  zIndex = "z-50",
}) {
  if (!open) return null;

  return ReactDOM.createPortal(
    <div className={`fixed inset-0 ${zIndex} flex items-center justify-center p-4`}>
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className={`bg-white dark:bg-gray-900 rounded-lg shadow-lg z-10 w-full ${maxWidth} max-h-[90vh] overflow-y-auto p-4 sm:p-6 transition-colors duration-300`}>
        {title && (
          <h3 className="text-lg font-semibold mb-3 dark:text-white">
            {title}
          </h3>
        )}
        <div className="px-0.5">{children}</div>
        {showCloseButton && (
          <div className="mt-4 text-right">
            <button
              onClick={onClose}
              className="px-4 py-2 rounded-md border border-gray-200 dark:border-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors"
            >
              Close
            </button>
          </div>
        )}
      </div>
    </div>,
    document.body
  );
}
